<template>
  <va-edit-layout>
    <videos-form :id="id" :title="title" :item="item"></videos-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
